import { debounce } from "lodash";
import { useEffect, useState } from "react";

export const getDebouncedCall = (delay: number = 1000) =>
  debounce((searchFunction: () => void) => {
    searchFunction();
  }, delay);

const handleDebouncedSearch = getDebouncedCall(500);

export const useDebounceSearch = ({
  onSearch = () => {},
  searchQuery,
}: {
  onSearch?: (searchQuery?: string | object) => void;
  searchQuery?: string | object;
}) => {
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  useEffect(() => {
    handleDebouncedSearch(() => {
      if (debouncedQuery !== searchQuery) {
        onSearch(searchQuery);
        setDebouncedQuery(searchQuery);
      }
    });
    // eslint-disable-next-line
  }, [searchQuery]);

  return {
    debouncedQuery,
  };
};
